<template>

<v-dialog v-model="dialog" width="500px">
  <v-card>
    <p class=".title ma-2">Add a contract to {{hspt.huis_code }} </p>
    <v-form ref="addHspt" v-model="addHsptValid">

      <v-row no-gutters>
       <v-col class="ma-2">
       <v-select v-model="hspt.cttp_nr" required :items="cttp_nrKeuzes" item-value="cttp_nr" item-text="cttptaal_oms" label="Contract type" dense :rules="cttp_nrRules"></v-select>
       </v-col>
      </v-row>  

      <v-row no-gutters>
       <v-col class="ma-2">
       <v-select v-model="hspt.hspt_prs_strct" required :items="hspt_prs_strctKeuzes" item-value="hspt_prs_strct" item-text="hspt_prs_strct" label="Price structure" dense :rules="hspt_prs_strctRules"></v-select>
       </v-col>
      </v-row> 

    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="addHspt" :disabled="!addHsptValid">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>

// import {bus} from "../../../main";

export default {
  data() { 
    return {
      dialog: false,
      addHsptValid: false,
      huis_encrid: null,
      cttp_nrKeuzes: [],
      hspt_prs_strctKeuzes: [],
      hspt: {},
      cttp_nrRules: [
          v => !!v || "A Contract type is required"
      ],
      hspt_prs_strctRules: [
          v => !!v || "A Price structure is required"
      ]  
    }
},
  methods: {
    open(huis_encrid) {
      var deze = this;
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huis/hspt/getHuisToAddHspt.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuisToAddHspt"
          },
          getHuisToAddHspt: {
            huis_encrid: huis_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hspt = res.data.getHuisToAddHspt;
            res.data.getHuisToAddHspt.cttp_nrKeuzes.forEach(function(cttp) {
            deze.cttp_nrKeuzes.push(cttp); 
           });
           res.data.getHuisToAddHspt.hspt_prs_strctKeuzes.forEach(function(prs) {
            deze.hspt_prs_strctKeuzes.push(prs); 
           });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addHspt() { 
      this.$axios
        .post("ares/json/ares/huis/hspt/addHspt.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "addHspt"
          },
          addHspt: {
            huis_encrid: this.hspt.huis_encrid,
            cttp_nr: parseInt(this.hspt.cttp_nr),
            hspt_prs_strct: this.hspt.hspt_prs_strct
          }
        })
        .then(res => {
          console.log('res', res)
          if (res.data.error) {
            console.log(res.data.error);
          }  else {          
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.addHspt.text,
              color: res.data.addHspt.color
            }); 
            this.$emit('updateData');
            this.dialog = false;
          }
        })
    },
  }
}
</script>

